/* eslint-disable react/display-name */
import React, { useState, forwardRef } from 'react';
import clsx from 'clsx';
// import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { ListItem, Button, Collapse, colors } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Link from '../../../Link';
import history from '../../../../history';

import { DiscardDialog } from 'components';

const CustomRouterLink = forwardRef((props, ref) => {
	return <div
		ref={ref}
		style={{ flexGrow: 1 }}
	>
		{/* <a href={props.to} className={props.className} style={props.style}>
      {props.title}  
    </a> */}
		<Link {...props} />
	</div>
});

const useStyles = makeStyles(theme => ({
	item: {
		display: 'block',
		paddingTop: 0,
		paddingBottom: 0,
		// paddingLeft: theme.spacing(2),
		// paddingRight: theme.spacing(2)
	},
	itemLeaf: {
		display: 'flex',
		paddingTop: 0,
		paddingBottom: 0,
    /* paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2) */
	},
	parentLabel: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2)
	},
	liPadding: {
		paddingLeft: theme.spacing(2),
		paddingRight: theme.spacing(2),
		fontSize: '16px',
	},
	button: {
		color: colors.blueGrey[800],
		padding: '10px 8px',
		justifyContent: 'flex-start',
		textTransform: 'none',
		letterSpacing: 0,
		width: '100%',
		paddingRight: '24px',
		fontWeight: theme.typography.fontWeightBold,
	},
	buttonLeaf: {
		color: theme.palette.primary.main,
		padding: '10px 8px',
		justifyContent: 'flex-start',
		textTransform: 'none',
		letterSpacing: 0,
		width: '100%',
		fontSize: 16,
		fontWeight: theme.typography.fontWeightMedium,
		'&.depth-0': {
			fontWeight: theme.typography.fontWeightMedium
		},
		'&.no-parent': {
			fontWeight: theme.typography.fontWeightRegular
		},
	},
	icon: {
		color: theme.palette.icon,
		display: 'flex',
		alignItems: 'center',
		marginRight: theme.spacing(1)
	},
	expandIcon: {
		marginLeft: 'auto',
		height: 16,
		width: 16
	},
	label: {
		display: 'flex',
		alignItems: 'center',
		marginLeft: 'auto'
	},
	activeText: {
		color: theme.palette.white,
		fontWeight: theme.typography.fontWeightMedium,
		'& $icon': {
			color: theme.palette.white
		}
	},
	active: {
		backgroundColor: theme.palette.primary.main,
		fontWeight: theme.typography.fontWeightMedium,
	}
}));

const NavigationListItem = props => {
	const {
		title,
		href,
		depth,
		children,
		icon: Icon,
		className,
		open: openProp,
		label: Label,
		hasParent,
		...rest
	} = props;

	const classes = useStyles();
	const [open, setOpen] = useState(openProp);
	const [openDialog, setOpenDialog] = useState(false);

	const handleToggle = () => {
		setOpen(open => !open);
	};

	const openDialogFunc = () => {
		setOpenDialog(openDialog => true);
	};

	const closeDialogFunc = () => {
		setOpenDialog(openDialog => false);
	};

	let paddingLeft = 8;

	if (children && depth > 0) {
		paddingLeft = 23;
	} else if (!children && depth > 0) {
		paddingLeft = 32 + 8 * depth;
	}

	const style = {
		paddingLeft
	};

	if (children) {
		return (
			<ListItem
				{...rest}
				className={clsx(classes.item, className)}
				disableGutters
			>
				<Button
					className={classes.button}
					onClick={handleToggle}
					style={style}
				>
					{Icon && <Icon className={classes.icon} />}
					<span className className={classes.parentLabel}>{title}</span>
					{open ? (
						<ExpandLessIcon
							className={classes.expandIcon}
							color="inherit"
						/>
					) : (
							<ExpandMoreIcon
								className={classes.expandIcon}
								color="inherit"
							/>
						)}
				</Button>
				<Collapse in={open}>{children}</Collapse>
			</ListItem>
		);
	} else {
		var activeClass = '';
		var activeText = '';

		var locationPath = history.location.pathname;

		locationPath = locationPath.replace('/admin/report/edit/', '/admin/reports/edit/').replace('/admin/report/view/', '/admin/reports');

		if (href == locationPath || (locationPath == "/admin/game/quarter-add" && href == '/admin/game/add') || (locationPath.search(href) >= 0) || (href == '/admin/event' && locationPath.search('/guest') >= 0)) {
			activeClass = classes.active;
		}

		if ((href == locationPath) || (href == '/admin/event' && locationPath.search('/guest') >= 0) || (locationPath.search(href) >= 0)) {
			activeText = classes.activeText;
		}

		return (
			<React.Fragment>
				<ListItem
					{...rest}
					className={clsx(classes.itemLeaf, className, (hasParent == false ? classes.liPadding : ''), activeClass)}
					disableGutters
				>
					<Button
						activeClassName={activeText}
						className={clsx(classes.buttonLeaf, `depth-${depth}`, (hasParent == false ? 'no-parent' : ''))}
						component={CustomRouterLink}
						style={style}
						to={href}
						title={title}
						onClick={(e) => {
							var matchArr = ['/admin/team/add', '/admin/client/add', '/admin/suite/add', '/admin/stadium/add', '/admin/event/add', '/admin/game/add', '/admin/report/add'];
							if (href != locationPath && (matchArr.indexOf(locationPath) > -1 || locationPath.indexOf('edit') > -1)) {
								openDialogFunc()
								e.preventDefault()
							}
						}}
					>
						{Icon && <Icon className={classes.icon} />}
						{title}
						{Label && (
							<span className={classes.label}>
								<Label />
							</span>
						)}
					</Button>
				</ListItem>
				<DiscardDialog
					onClose={() => closeDialogFunc()}
					open={openDialog}
					link={href}
				/>
			</React.Fragment>
		);
	}
};

NavigationListItem.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	depth: PropTypes.number.isRequired,
	href: PropTypes.string,
	icon: PropTypes.any,
	label: PropTypes.any,
	open: PropTypes.bool,
	title: PropTypes.string.isRequired
};

NavigationListItem.defaultProps = {
	depth: 0,
	open: false
};

export default NavigationListItem;
